export default __webpack_public_path__ + "static/media/Chulainn's Gift.004df525.jpg";